<template>
  <div class="main-panel">
    <div class="content-wrapper sucursales-shell">
      <div class="cardplay sucursales-config-shell">
        <div class="row sucursales-header g-3 align-items-center">
          <div class="col-12 col-lg-8">
            <h2 class="sucursales-title mb-1">Sucursales</h2>
            <p class="sucursales-subtitle mb-0">Administra las sucursales usadas en solicitudes, cartera y usuarios.</p>
          </div>
          <div class="col-12 col-lg-4 d-flex justify-content-lg-end">
            <router-link class="btn btn-primary sucursales-main-btn" to="/sucursal/0">
              <i class="fa-solid fa-plus"></i>
              Nueva Sucursal
            </router-link>
          </div>
        </div>

        <div class="table-card">
          <div v-if="!ready" class="loading-shell">
            <span class="spinner-border spinner-border-sm" role="status"></span>
            Cargando sucursales...
          </div>

          <div v-else-if="sucursales.length === 0" class="empty-shell">
            No hay sucursales configuradas.
          </div>

          <div v-else class="table-responsive horizontal-scrollable">
            <table class="table table-compact table-striped align-middle sucursales-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Descripcion</th>
                  <th>Ubicacion</th>
                  <th>Encargado</th>
                  <th>Estado</th>
                  <th class="text-end">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="sucursal in sucursales" :key="sucursal.id">
                  <td class="branch-name">{{ sucursal.nombre }}</td>
                  <td>{{ sucursal.descripcion || "-" }}</td>
                  <td>{{ sucursal.ubicacion || "-" }}</td>
                  <td>{{ sucursal.encargadoId || "-" }}</td>
                  <td><span class="badge bg-success sucursal-badge">Activa</span></td>
                  <td>
                    <div class="table-actions">
                      <router-link class="btn btn-light icon-btn" :to="`/sucursal/${sucursal.id}`">
                        <i class="fa-solid fa-pen-to-square"></i>
                      </router-link>
                      <button class="btn btn-light icon-btn danger" type="button" @click="deleteSucursal(sucursal)">
                        <i class="fa-solid fa-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Security from "../security";

export default {
  data() {
    return {
      sucursales: [],
      ready: false,
    };
  },
  beforeMount() {
    Security.requireToken();
    this.fetchSucursales();
  },
  methods: {
    fetchSucursales() {
      this.ready = false;
      fetch(process.env.VUE_APP_API_URL + "/admin/sucursales/all", Security.requestOptions({}))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.showError(response.message);
            return;
          }

          this.sucursales = response.data?.sucursales || [];
        })
        .catch((error) => this.showError(error))
        .finally(() => {
          this.ready = true;
        });
    },
    deleteSucursal(sucursal) {
      Swal.fire({
        title: "Eliminar sucursal",
        text: sucursal.nombre,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (!result.isConfirmed) return;

        fetch(
          process.env.VUE_APP_API_URL + "/admin/sucursales/delete",
          Security.requestOptions({ id: sucursal.id })
        )
          .then((response) => response.json())
          .then((response) => {
            if (response.error) {
              this.showError(response.message);
              return;
            }

            this.fetchSucursales();
          })
          .catch((error) => this.showError(error));
      });
    },
    showError(message) {
      Swal.fire({
        icon: "error",
        title: "No se pudo completar",
        text: String(message),
      });
    },
  },
};
</script>

<style scoped>
.sucursales-shell {
  background: linear-gradient(165deg, #f6f7fa 0%, #edf0f5 48%, #fafafa 100%);
  min-height: 100vh;
}

.cardplay {
  border-radius: 22px;
  border: 1px solid #e5e7eb;
  padding: 24px;
  background-color: #ffffff;
  box-shadow: 0 22px 54px rgba(15, 23, 42, 0.07);
}

.sucursales-header {
  background: linear-gradient(120deg, #20242b 0%, #343a43 72%, #4b5563 100%);
  border-radius: 16px;
  color: #fff;
  padding: 14px 16px;
  margin-bottom: 18px;
}

.sucursales-title {
  color: #fff;
  font-weight: 700;
  margin: 0;
}

.sucursales-subtitle {
  color: #e5e7eb;
  font-size: 0.93rem;
}

.sucursales-main-btn {
  border-radius: 10px;
  min-height: 38px;
  padding-inline: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.table-card {
  background: #ffffff;
  border: 1px solid #e3e7ee;
  border-radius: 14px;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05);
  padding: 14px;
}

.horizontal-scrollable {
  overflow-x: auto;
  white-space: nowrap;
}

.sucursales-table thead th {
  background: #f3f5f8;
  color: #111827;
  border-bottom: 1px solid #e5e7eb;
  font-size: 0.86rem;
}

.branch-name {
  color: #111827;
  font-weight: 700;
}

.sucursal-badge {
  border-radius: 999px;
  padding: 0.36rem 0.64rem;
}

.table-actions {
  display: flex;
  justify-content: flex-end;
  gap: 7px;
}

.icon-btn {
  width: 38px;
  height: 38px;
  border-radius: 9px;
  border: 1px solid #e5e7eb;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #374151;
}

.icon-btn.danger {
  color: #b91c1c;
}

.loading-shell,
.empty-shell {
  color: #4b5563;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 600;
  min-height: 120px;
}
</style>
